export default "/images/vendor/flag-icon-css/flags/4x3/ga.svg?4257c8ec8a129da794b2a34583d3988c";